import React from "react";
import './dotted-button.scss';
import {DottedIconButton} from "../../../dotted-icon-button";
import PropTypes from "prop-types";
import {canUserAccessBrandKits} from "@Libraries/brands-library.js";

/**
 * a dotted button that shows premium dialog for non-premium user and goes to brand for premium user
 * @author Afifa Saleem <afifa@250mils.com>
 */
const DottedButton = ({buttonText, buttonIcon, onClick}) => {
    const goToMyStuff = () => {
        window.location.href = PMW.util.site_url('posters/mine#/brands');
    }

    /**
     * handler for when button is clicked
     */
    const onButtonClick = () => {
        if (canUserAccessBrandKits()) {
            onClick(goToMyStuff);
        } else {
            PMW.showPremiumOnlyFeatureDialog(PMW.PREMIUM_ONLY_FEATURE_NAME_BRANDS);
        }
    }

    return (
        <DottedIconButton
            btnText={buttonText}
            btnIcon={buttonIcon + ' content-body'}
            direction={'horizontal'}
            className={'add-brand'}
            textClasses={'body-xs'}
            onClick={onButtonClick}
        />
    )
}
DottedButton.propTypes = {
    /**
     * the icon-* class of the icon to display on the button
     */
    buttonIcon: PropTypes.string.isRequired,
    /**
     * the text to display on the button
     */
    buttonText: PropTypes.string.isRequired,
    /**
     * The click handler to attach to the button
     */
    onClick: PropTypes.func,
}

DottedButton.defaultProps = {
    onClick: $.noop()
}
export default DottedButton;
